// extracted by mini-css-extract-plugin
export default {"root":"ApplicationsTable_root__YZ6Lu","header":"ApplicationsTable_header__ZTBhv","footer":"ApplicationsTable_footer__ts3Gj","next-disabled":"ApplicationsTable_next-disabled__mBuF6"};